/**
 * The About component
 */
import React from "react";
import Carousel from "react-multi-carousel";

import { Container, Row, Col } from "reactstrap";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import FormattedNumber from "../../FormattedNumber";
import LazyLoad from "react-lazyload";
import ResponsivePicture from "../../ResponsivePicture";
import { REACT_APP_SHOP_CDN_SERVER } from "../../../utils/env";

/**
 * Stateless react component to render the About page
 * @param {Object} props the props passed to the page.
 */
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 5000, min: 3000 },
    items: 6,
    partialVisibilityGutter: 30,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    partialVisibilityGutter: 30,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
    partialVisibilityGutter: 30,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    partialVisibilityGutter: 80,
  },
};

const RelatedProducts = ({ relatedProducts }, context) => {
  const { language } = useSelector((state) => {
    return {
      language: state.i18nState.lang,
    };
  });

  return (
    <Container className="mt-5">
      <Row>
        <h2 className="h4 text-center d-block w-100">
          {context.t("Similar items bought by other customers")}
        </h2>

        <Col md={{ offset: 1, size: 10 }}>
          <Carousel
            slidesToSlide={1}
            partialVisible
            responsive={responsive}
            autoPlay
            autoPlaySpeed={8000}
            infinite
            keyBoardControl
            shouldResetAutoplay
            swipeable
            draggable
            pauseOnHover
            partialVisbile
            ssr
          >
            {relatedProducts?.map((item, i) => (
              <div className="m-4" key={i}>
                <Link
                  to={"/" + language + "/i/" + item.slug}
                  style={{ color: "#000" }}
                >
                  <div
                    className="d-block bg-light p-2 mb-2"
                    style={{
                      height: "200px",
                      borderRadius: "1rem",
                      overflow: "hidden",
                      textAlign: "center",
                    }}
                  >
                    <LazyLoad>
                      <ResponsivePicture
                        mediumData={{
                          sources: [
                            {
                              url: `${REACT_APP_SHOP_CDN_SERVER}${item?.image?.url}`,
                              content_type: "image/jpeg",
                              media: "(min-width: 0em)",
                            },
                          ],
                        }}
                        style={{
                          maxWidth: "90%",
                          height: "90%",
                          margin: "auto",
                        }}
                        altTitle={item?.name + " " + item?.subtitle}
                      />
                    </LazyLoad>
                  </div>
                  <span className="d-block h5">{item?.name}</span>

                  {item?.saleprice && (
                    <span className="sale-price">
                      {context.t("from") + " "}
                      <FormattedNumber
                        value={parseFloat(item?.saleprice / 100)}
                        language={language}
                        unit="€"
                        decimals={2}
                      />
                      <s>
                        <FormattedNumber
                          value={parseFloat(item?.price)}
                          language={language}
                          unit="€"
                          decimals={2}
                        />
                      </s>
                    </span>
                  )}

                  {(!item?.saleprice || item?.saleprice === 0) && (
                    <>
                      {context.t("from") + " "}
                      <FormattedNumber
                        value={parseFloat(item.price)}
                        language={language}
                        unit="€"
                        decimals={2}
                      />
                    </>
                  )}
                  {!!item?.basicprice && (
                    <div className="text-remark">
                      ({context.t("from")}{" "}
                      <FormattedNumber
                        className="basic-price"
                        value={parseFloat(item?.basicprice?.price / 100)}
                        language={language}
                        unit={`€ / ${
                          item?.basicprice?.unit ? item?.basicprice?.unit : "m²"
                        }`}
                        decimals={2}
                      />
                      )
                    </div>
                  )}
                  {!item?.basicprice && (
                    <div className="text-remark">
                      <br />
                    </div>
                  )}
                </Link>
              </div>
            ))}
          </Carousel>
        </Col>
      </Row>
    </Container>
  );
};

/**  define proptype for the 'translation' function  */
RelatedProducts.contextTypes = {
  t: PropTypes.func,
};

export default RelatedProducts;
